import { STYLES_VARIABLES } from 'constants/styleVariables';

const Footer = () => {
  return (
    <div style={{ minWidth: '1120px' }}>
      <footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: `${STYLES_VARIABLES.GRAY_01}`,
          padding: '40px 130px',
          fontSize: '12px',
          lineHeight: '18px',
          color: `${STYLES_VARIABLES.GRAY_07}`,
          marginTop: '50px',
        }}
      >
        <div>
          <div className="flex gap16">
            <a href="https://www.bhu.ac.kr/www/main">부산보건대학교</a>
            <span>|</span>
            <a href="https://www.kai-i.com/">(주) 카이아이컴퍼니</a>
          </div>
          <p style={{ margin: '4px 0' }}>
            (49318)부산광역시 사하구 사리로55번길16 (괴정동) 부산보건대학교
            혜인관 603호
          </p>
          <div className="flex gap16">
            <a href="tel:051-200-3483">TEL. 051 - 200 - 3483</a>
            <a href="tel:051-200-3484">FAX. 051 - 200 - 3484</a>
          </div>
        </div>
        <div>
          <p>
            카이아이 CS 문의 : <a href="tel:1670-2628">1670-2628</a>
          </p>
          <p className="mt4">
            운영시간 : 평일 (10:00~17:00) / 점심시간 (12:00~13:00) / 주말 및
            공휴일 휴무
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
